<template>
  <v-row justify="center">
    <v-dialog v-model="imageShow" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-subtitle class="subtitle ml-6" v-if="subtitle">{{subtitle}}</v-card-subtitle>
        <v-card-text class="mt-2">
          <v-img :src="imageSrc" contain v-if="imageSrc">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="accent"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
        <v-btn class="close-image-btn" color="accent" icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data: () => ({}),
  created() {},
  mounted() {},
  computed: {
    imageShow() {
      return this.imageSrc !== "" && this.imageSrc !== null;
    }
  },
  methods: {
    close() {
      this.$emit("update:imageSrc", "");
    }
  },
  watch: {},
  props: {
    imageSrc: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: "Magnified Image"
    },
    subtitle: {
      type: String,
      default: ""
    },
    width: {
      type: [Number, String],
      default: "auto"
    }
  }
};
</script>

<style lang="scss" scoped>
.close-image-btn {
  position: absolute;
  right: 0;
  top: 0;
  margin: 10px 10px 0 0;
}
</style>